










































import { listFactory } from '@/main/pages';
import { previewButton } from '@/main/utils/tableOperations';
import { showAlert } from '@/main/utils/notifications';
import { isUserPartsManager, OpenPartMaintenance } from '@/main/utils/commonFunctions';

import { apiProvider } from './api';
import { store } from './store/list';
import { NAME, RequestStatus, EMAIL_TYP_PZN, GRID_COLUMNS } from './constants';

export default listFactory(NAME, store).extend({
	data() {
		return {
			showDialog: false,
			ReturnStatus: RequestStatus.PENDING,
			RejectedComments: '',
			ReqObj: {
				PartNo: null as string | null,
				AdjustmentType: null as number | null,
				AdjustmentQty: null as number | null,
				PartRecId: null as number | null,
				RequestStatusId: null as number | null,
				ReqReasonId: null as number | null,
				ApprovedById: null as number | null,
				CreatedById: null as number | null,
				UpdatedById: null as number | null,
				RequestRejectionCommt: null as string | null,
			},
			approverData: [] as any,
			isPendingSelected : false,
			gridCols: GRID_COLUMNS,
		};
	},
	methods: {
		OpenPartMaintenance,
		getColumnLabel(columnName:any) {
			return `${ '* '}${this.Localize(columnName)}`;
		},
		async viewClick(event: any, cells: any) {
			if (event.data!.STATUS.toUpperCase() !== RequestStatus[RequestStatus.PENDING]) {
				showAlert({
					message: this.LocalizeChyboveHlasky('adjustmentAlreadyApproved'),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
						closeOnPressEscape: true,
						closeOnClickModal: true,
					},
				});
				return;
			}
			this.RejectedComments = ''
			this.ReturnStatus = RequestStatus.PENDING;
			this.showDialog = true;
			this.ReqObj = {
				PartNo: event.data!.ITEM_NO,
				AdjustmentQty: event.data!.ADJUSTMENT_QTY,
				AdjustmentType: event.data!.ADJUSTMENT_TYPE,
				PartRecId: event.data!.PART_REC_ID,
				RequestStatusId: this.ReturnStatus,
				ReqReasonId: event.data!.REQUEST_STATUS_ID,
				ApprovedById: this.pracovnik.PracovnikId,
				CreatedById: this.pracovnik.PracovnikId,
				UpdatedById: this.pracovnik.PracovnikId,
				RequestRejectionCommt: this.RejectedComments,
			};
		},
		async approveRejectPartInventory() {
			this.ReqObj.RequestRejectionCommt = this.RejectedComments;
			this.ReqObj.RequestStatusId = this.ReturnStatus;
			this.showDialog = false;

			const requestType = this.LocalizePopisPoli(RequestStatus[this.ReturnStatus || RequestStatus.PENDING]);
			const emailDto = {
				SenderId: this.ReqObj.ApprovedById,
				ReceiverId: this.ReqObj.CreatedById,
				PartNo: this.ReqObj.PartNo,
				RequestType: requestType,
				EmailTemplateId: EMAIL_TYP_PZN.INV_ADJUST_NOTIFY,
			};
			this.startLoading();
			const { data: invAdjustmentResp } = await apiProvider.approveInventoryAdjustment(this.ReqObj);
			if (invAdjustmentResp === RequestStatus.APPROVED) {
				showAlert({
					message: this.LocalizeAndReplace(this.LocalizeChyboveHlasky('ApprovInvenAdSuccessMsg'), { key: '<PART_NO>', value: `${this.ReqObj.PartNo} : ${requestType}` }),
					title: this.LocalizeChyboveHlasky('DMS3_InfoTitle'),
					options: {
						type: 'info',
						closeOnPressEscape: true,
						closeOnClickModal: true,
					},
				});
				await apiProvider.sendEmailNotification(emailDto);
			}
			if (invAdjustmentResp === -1) {
				this.showErrorAlert({ message: this.LocalizeChyboveHlasky('AdjustQtyLessThanAvaQty'), options: { type: 'error' }, localizeMessage: false });
			}
			this.endLoading();
		},
		onReasonUpdate() {
			this.RejectedComments = '';
                
			if(this.ReturnStatus !==null)
			{
				this.isPendingSelected =true;
			}
			else
			{
				this.isPendingSelected =false;
			}
		},
		modalLabel(): string {
			return this.LocalizeFormular('approveRejectModel');
		},
	},
	computed: {
		isUserPartsManager(): boolean {
			return isUserPartsManager(this.pracovnik.PracovnikOzn, this.userRoles);
		},
		disbaledPartInventory(): boolean {
			return this.ReturnStatus === RequestStatus.REJECTED && this.RejectedComments.length < 1;
		},
		isRemarksVisible(): boolean {
			return this.ReturnStatus === RequestStatus.REJECTED;
		},
		isReturnStatusSelected(): boolean {
			if(!this.isPendingSelected)
			{
             return true;
			}
			else{
				return false;
			}
		},
	},
});
